import { render, staticRenderFns } from "./LinkComponent.vue?vue&type=template&id=ef4a940e&scoped=true"
import script from "./LinkComponent.vue?vue&type=script&lang=js"
export * from "./LinkComponent.vue?vue&type=script&lang=js"
import style0 from "./LinkComponent.vue?vue&type=style&index=0&id=ef4a940e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4a940e",
  null
  
)

export default component.exports